import { render, staticRenderFns } from "./ExceptionsOV.vue?vue&type=template&id=39f940b6&scoped=true&lang=pug"
import script from "./ExceptionsOV.vue?vue&type=script&lang=js"
export * from "./ExceptionsOV.vue?vue&type=script&lang=js"
import style0 from "./ExceptionsOV.vue?vue&type=style&index=0&id=39f940b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f940b6",
  null
  
)

export default component.exports